<template>
  <b-navbar 
    toggleable="md" 
    type="dark">
    <b-navbar-toggle target="nav_collapse"/>
    <b-navbar-brand to="/">
      <img
        alt="Greenbank logo"
        src="../assets/greenbank-logo.svg">
    </b-navbar-brand>
    <b-navbar-nav>
      <b-nav-item 
        class="nav-btn" 
        to="/dashboard"><icon
          name="table"
          scale="2"/></b-nav-item>
      <b-nav-item 
        class="nav-btn" 
        to="/dashmap"><icon
          name="map-o"
          scale="2"/></b-nav-item>
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto">
      <b-nav-item 
        v-if="!isAuthenticated" 
        class="nav-btn" 
        to="/signIn"><span class="nav-username">Sign In</span></b-nav-item>
      <b-nav-item-dropdown 
        v-if="isAuthenticated" 
        right>
        <template slot="button-content">
          <icon name="user-circle"/><strong class="nav-username">{{ user.username }}</strong>
        </template>
        <b-row 
          class="justify-content-md-center" 
          style="margin:5px">
          <b-dropdown-item to="/changePassword"><span class="nav-username">Change Password</span></b-dropdown-item>
          <b-dropdown-item to="/signOut"><icon name="sign-out"/><span class="nav-username">Sign Out</span></b-dropdown-item>
        </b-row>
      </b-nav-item-dropdown>
      <b-nav-item 
        class="nav-btn" 
        href="https://www.facebook.com/greenbankwaste/"><icon
          name="facebook-square"
          scale="1.5"/></b-nav-item>
      <b-nav-item 
        class="nav-btn" 
        href="https://twitter.com/greenbankwaste"><icon
          name="twitter-square"
          scale="1.5"/></b-nav-item>
      <b-nav-item 
        class="nav-btn" 
        href="https://www.linkedin.com/company/5341581/"><icon
          name="linkedin-square"
          scale="1.5"/></b-nav-item>
    </b-navbar-nav>
  </b-navbar>    
</template>

<script>
import { mapState } from 'vuex'

import 'vue-awesome/icons/user-circle'
import 'vue-awesome/icons/sign-out'
import 'vue-awesome/icons/facebook-square'
import 'vue-awesome/icons/twitter-square'
import 'vue-awesome/icons/linkedin-square'
import 'vue-awesome/icons/table'
import 'vue-awesome/icons/map-o'

export default {
    name: 'Navbar',
    computed: {
        ...mapState({
            user: state => state.auth.user,
            isAuthenticated: state => state.auth.isAuthenticated,
        })
    },
    methods: {
        signIn() {
            this.$store.dispatch('signIn')
        }
    }
}
</script>

<style scoped>
.navbar {
    background-color: #563d7c;
}
.navbar-nav .nav-link {
    color: #cbbde2;
}
.nav-username {
  padding-left: .5em;
  padding-right: .5em;
}
</style>
